import { render, staticRenderFns } from "./partrGroup_js_report.vue?vue&type=template&id=af55f550&scoped=true"
import script from "./partrGroup_js_report.vue?vue&type=script&lang=js"
export * from "./partrGroup_js_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af55f550",
  null
  
)

export default component.exports